import { CheckedIcon } from '@/assets/SVGs/icons/CheckedIcon';
import AppBade from '@/components/ui/AppBade';
import { MinusIcon } from '@/assets/SVGs/icons/MinusIcon';
import { IUserData } from '@/types';
import AppButton from '@/components/ui/AppButton';
import { Link } from 'react-router';
import { Trash2, Eye, BellRing } from 'lucide-react';

interface UserDataFormatterProps {
  data: IUserData[];
  onDelete: (user: IUserData) => void;
}

export const userDataFormatter = (
  data: IUserData[],
  onDelete?: (user: IUserData) => void,
  onSendNotification?: (user: IUserData) => void
) => {
  return data.map((item: IUserData) => {
    return {
      ...item,
      fullName: (
        <Link
          to={`/users/profile/?uid=${item._id}`}
          className="font-medium text-coal-800 transition-colors hover:text-primary"
        >
          {item.fullName}
        </Link>
      ),
      isVerified: item.isVerified ? (
        <AppBade circle size="small" variant="label" color="success" iconOnly icon={CheckedIcon} />
      ) : (
        <AppBade circle size="small" variant="label" color="error" iconOnly icon={MinusIcon} />
      ),
      isPhoneNumberVerified: item.isPhoneNumberVerified ? (
        <AppBade circle size="small" variant="label" color="success" iconOnly icon={CheckedIcon} />
      ) : (
        <AppBade circle size="small" variant="label" color="error" iconOnly icon={MinusIcon} />
      ),
      isActive: item.isActive ? (
        <AppBade circle size="small" variant="label" color="success" iconOnly icon={CheckedIcon} />
      ) : (
        <AppBade circle size="small" variant="label" color="error" iconOnly icon={MinusIcon} />
      ),
      isBlocked: item.isBlocked ? (
        <AppBade size="small" variant="label" color="error">
          Blocked
        </AppBade>
      ) : (
        <AppBade size="small" variant="label" color="success">
          No
        </AppBade>
      ),
      role:
        item.role === 'user' ? (
          <AppBade size="small" variant="label" color="info">
            user
          </AppBade>
        ) : item.role === 'admin' ? (
          <AppBade size="small" variant="label" color="success">
            admin
          </AppBade>
        ) : item.role === 'superAdmin' ? (
          <AppBade size="small" variant="label" color="primary">
            Super Admin
          </AppBade>
        ) : (
          <AppBade size="small" variant="label" color="warning">
            {item.role}
          </AppBade>
        ),
      actions: (
        <div className="flex gap-1.5">
          <Link to={`/users/profile/?uid=${item._id}`}>
            <AppButton size="xs" isIconOnly title="View profile">
              <Eye className="h-4 w-4" />
            </AppButton>
          </Link>
          <AppButton
            size="xs"
            isIconOnly
            title="Send push notification"
            onClick={() => onSendNotification?.(item)}
          >
            <BellRing className="h-4 w-4 text-primary" />
          </AppButton>
          <AppButton size="xs" isIconOnly onClick={() => onDelete?.(item)}>
            <Trash2 className="h-4 w-4 text-danger" />
          </AppButton>
        </div>
      ),
    };
  });
};
